var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import $store, { SiteStoreState, updateSiteStore, convert } from "../stores/SiteStore";
import Scroller from "../components/Scroller";
import relianceLogo from "../media/logo.png";
import animateSpin from "../media/loader.gif";
import { classNames } from "../util/common-utilities";
import { useStore } from "effector-react";
import { useEffect } from "react";
function Posting() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f;
    var site_store = useStore($store);
    var spinnerWrapperStyle = {
        backgroundColor: "#242425",
    };
    useEffect(function () {
        var postIt = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (site_store.state === SiteStoreState.POSTING) {
                    convert({ callback: updateSiteStore });
                }
                return [2 /*return*/];
            });
        }); };
        postIt();
    }, [site_store.state]);
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: classNames("w-full grid place-items-center h-screen"), style: spinnerWrapperStyle }, { children: _jsxs("div", __assign({ className: classNames("text-white w-2/3 grid place-items-center") }, { children: [((_b = (_a = site_store.siteRaw) === null || _a === void 0 ? void 0 : _a.firm) === null || _b === void 0 ? void 0 : _b.interstitialLogo) ? (_jsx("img", { className: classNames("w-4/5 px-3"), src: "".concat(site_store.strippedUri, "/media/").concat((_d = (_c = site_store.siteRaw) === null || _c === void 0 ? void 0 : _c.firm) === null || _d === void 0 ? void 0 : _d.interstitialLogo), alt: "Please Wait" }, void 0)) : (_jsx("img", { className: classNames("w-4/5 px-3"), src: relianceLogo, alt: "Reliance Logo" }, void 0)), _jsx("p", __assign({ className: classNames("text-xl text-center p-3 pb-0") }, { children: "Please wait a moment" }), void 0), _jsx("div", { children: _jsx("img", { className: classNames(""), src: animateSpin, alt: "Loading" }, void 0) }, void 0), !((_f = (_e = site_store.siteRaw) === null || _e === void 0 ? void 0 : _e.firm) === null || _f === void 0 ? void 0 : _f.interstitialLogo) && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: classNames("text-center text-xl pb-3 pt-0") }, { children: "Potential Compensation to Cover" }), void 0), _jsx(Scroller, { items: ["Pain & Suffering", "Justice", "Medical Bills", "Emotional Distress"], n: "text-3xl text-center" }, void 0)] }, void 0))] }), void 0) }), void 0) }, void 0));
}
export default Posting;
